import { ColoredBanner } from 'shared/components/ColoredBanner';
import { useSobFilters } from 'shared/hooks';
import { getSobGuideArticleBannerContent } from 'shared/utils/banners/getSobGuideArticleBannerContent';

export const SobGuideArticleBanner: React.FC = () => {
  const { dealType, offerType } = useSobFilters();

  return <ColoredBanner {...getSobGuideArticleBannerContent(dealType, offerType)} />;
};
